
























































import { Component, ModelSync, Prop } from "vue-property-decorator";
import { Popup, Tabs, Tab, List, Skeleton } from "vant";
import { WithInject } from "../Mixins";
import LiveComment from "./liveroom/LiveComment.vue";
import ChatComment from "./chatroom/ChatComment.vue";
import { IGetDetail } from "@/api/types";

@Component({
  components: {
    Popup,
    Tabs,
    Tab,
    List,
    LiveComment,
    ChatComment,
    Skeleton
  }
})
export default class CommentPop extends WithInject {
  @ModelSync("show", "change", { type: Boolean })
  private _show!: boolean;
  // 直播间详情
  @Prop({ type: Object, default: () => {} })
  detail!: IGetDetail["data"];
  // 控制重新渲染tab内组件的变量
  render = true;
  // tab
  active = 0;
}
